import { IAction } from './action';

export class SetIcon implements IAction {
    constructor(public icon: string) { }
}
